/**
 * Login-Seite (LEH-002, auf Authentik umgestellt in issue #6).
 *
 * Authentik übernimmt den eigentlichen Login (OIDC/PKCE) — hier nur der
 * Auslöser. Wird nur gerendert, wenn OIDC konfiguriert ist (siehe App.tsx).
 * Wenn der User bereits eingeloggt ist, Redirect zum Dashboard.
 */

import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { useAuth } from "@/hooks/useAuth"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

export default function Login() {
  const { login, oidcAuth, oidcLoading } = useAuth()
  const navigate = useNavigate()

  // Bereits eingeloggt → Dashboard
  useEffect(() => {
    if (oidcAuth && !oidcLoading) {
      navigate("/", { replace: true })
    }
  }, [oidcAuth, oidcLoading, navigate])

  if (oidcLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Lädt…
      </div>
    )
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-primary">FactoryERP</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Anmeldung über das Lehner-Login (Authentik, SSO/MFA).
          </p>
          <Button className="w-full" onClick={login} disabled={oidcLoading || oidcAuth}>
            Anmelden
          </Button>
        </CardContent>
      </Card>
    </main>
  )
}
